import {
  Alignments,
  Icons,
  TextButton,
} from "@polestar/component-warehouse-react";
import React from "react";

interface Props {
  readonly label?: string;
  readonly transformedMeta?: Record<string, unknown>;
}

const CookieButton: React.FC<Props> = ({ label, transformedMeta }) => {
  const handleClick = () => {
    window.Optanon.ToggleInfoDisplay();
  };

  return (
    <TextButton
      // Since this is the way datocms suggest and it can be anything spreadin is allowed
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...transformedMeta}
      data-testid="legal-cookie-button"
      iconPosition={Alignments.right}
      icon={Icons.arrowRight}
      onClick={handleClick}
    >
      {label}
    </TextButton>
  );
};

export default CookieButton;
